import React, { useEffect, useState } from 'react'
import { Card, Row, Form, Col, Select,Input, DatePicker, Radio, Button, Modal, Descriptions, message } from 'antd';
import { PalletType } from 'libs/shared-models/common-models/src/lib/enum/pallet-type.enum';
import moment from 'moment';
import { GlobalVariableValues, PackageTypeEnum, PackingStatus, ProductCategoryDropDown, ProductCategoryEnum, StockTypeDropDown, StockTypesEnum, StockTypeStatus, TransactionType, TransactionTypeDropDown, UnitRequest } from '@gtpl/shared-models/common-models';
import { EndCustomersService, HrmsEmpDetService, PackingMethodService, RackPositionService, UnitcodeService } from '@gtpl/shared-services/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { ForkLiftJobService, StockInService } from '@gtpl/shared-services/warehouse-management';
import { SaleOrderDropDownDto } from 'libs/shared-models/sale-management/src/lib/sale-order/sale-order-drop-down.dto';
import { HrmsEmployeeDetailsDto, PackingMethodDto, ZoneDropDownDto } from '@gtpl/shared-models/masters';
import { ForkliftJobcodesDropDownDto, ItemsDetails, SaleOrderDetailViewInfoDTO, SaleOrderItemsDTO } from '@gtpl/shared-models/sale-management';
import { WarehouseDashboardService } from '@gtpl/shared-services/analytics';
import { BrandsInfo } from 'libs/shared-models/masters/src/lib/endCuctomer/brands-model';
import { CodeListMainService } from '@gtpl/shared-services/planning';
import { useLocation } from 'react-router-dom';
import { CheckSoItemExistReq, JobIdRequest, SaleOrderIdRequest, SOVarientIdReq, StockInRequestDto } from '@gtpl/shared-models/warehouse-management';
import Table, { ColumnProps } from 'antd/lib/table';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import ItemDetailsForm from './item-details';
import StockinPrint from './stock-in-print';
import TextArea from 'antd/lib/input/TextArea';
import { BaleService } from '@gtpl/shared-services/raw-material-procurement';
import { BaleDateReq } from '@gtpl/shared-models/raw-material-procurement';


const SpsaWOStockIn = () => {
 let stockType = StockTypeDropDown.filter(e => {return(e.name != 'Super Dummy' && e.name != 'Anticipated')});
   let transactionTypeDropDown = TransactionTypeDropDown.filter(e => {return(e.name == 'Fresh Production')});
  //  let transactionTypeDropDown = TransactionTypeDropDown.filter(e => {return(e.name != 'Complements' && e.name != 'Stock Transfer' && e.name != 'Reworking' && e.name != 'Lab Samples' && e.name != 'Purchase Product')});
   let categories = ProductCategoryDropDown;
   const [form] = Form.useForm();
   const [hideColumns, setHideColumns] = useState<boolean>(false)
   const [hidePackStyle, setHidePackStyle] = useState<boolean>(false)
   const [hidejobType,setHidejobType] = useState<boolean>(true)
   const [itemValidation, setItemValidation] = useState<boolean>(false)
   const [hideRackColumns, setHideRackColumns] = useState<boolean>(false)
   const [isUpdate, setIsUpdate] = useState<boolean>(false)
   const [saleOrderId, setSaleOrderId] = useState<number>(undefined)
   const [jobId,setJobId] = useState<number>(undefined)
   const [jobCode,setJobCode] = useState<string>(undefined)
   const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
   const [packStyle, setPackStyle] = useState<PackingMethodDto[]>([]);
   const [stockStatus, setStockStatus] = useState<string>(undefined)
   const [saleOrderItemDetails, setSaleOrderItemDetails] = useState<SaleOrderItemsDTO>(undefined)
   const [saleOrderItemsData, setSaleOrderItemsData] = useState<ItemsDetails[]>([])
   const [saleOrderData, setSaleOrderData] = useState<SaleOrderDropDownDto[]>([])
   const [traceCodeList, setTraceCodeList] = useState<any[]>([])
   const [jobcodesData,setJobcodesData] = useState<ForkliftJobcodesDropDownDto[]>([])
   const [rackPostionsDropDown, setRackPostionsDropDown] = useState<any[]>([])
   const [zoneDropDown, setZoneDropDown] = useState<ZoneDropDownDto[]>([])
   const [saleOrderDetails, setSaleOrderDetails] = useState<SaleOrderDetailViewInfoDTO>(undefined)
   const [itemDetailsGridData, setItemDetailsGridData] = useState<any>(undefined)
   const [masterBrandData, setMasterBrandData] = useState<any>(undefined)
   const [varientId, setVarientId] = useState<number>(undefined)
   const [customerBrandsData, setCustomerBrandsData] = useState<BrandsInfo[]>([]);
   const [selectedCategory, setSelectedCategory] = useState<string>('');
   const [selectedCurrency, setSelectedCurrency] = useState<number>(1);
   const [itemsKey, setItemsKey] = useState<number>(10);
   const [btnDisable, setBtnDisable] = useState<boolean>(false);
   const [isJobcodeRequired,setIsJobcodeRequired] = useState<boolean>(false);
   const [isTracecodeRequired,setIsTracecodeRequired] = useState<boolean>(true);
   const [isModalVisible,setIsModalVisible] = useState<boolean>(false);
   const [modalName,setModalName] = useState<string>('')
   const unitcodeService = new UnitcodeService();
   const saleOrderService = new SaleOrderService();
   const packingMethodService = new PackingMethodService();
   const rackPositionService = new RackPositionService();
   const endcustomerservice = new EndCustomersService();
   const stockInService = new StockInService();
   const forkliftService = new ForkLiftJobService();
   const codeListMainService = new CodeListMainService();
   const employeeService = new HrmsEmpDetService();
   const [reportingLogId,setReportingLogId] = useState<any>()
   const [products,setProducts] = useState<any[]>([])
   const [dummyProductPackStyles,setDummyProductPackStyles] = useState<any[]>([])
   const [saveFlag,setsaveFlag] = useState<boolean>(true)
   const warehouseService = new WarehouseDashboardService()
   const [todayStockInInfo,setTodayStockInInfo] = useState<any[]>([])
   const [page,setPage] = useState<number>(1)
   const [prevReportedQty,setPrevReportedQty] = useState<number>()
   const [unitCodes,setUnticodes] = useState<any[]>([])
   const [stockTypeDisable,setStockTypeDisable] = useState<boolean>(false)
   const [year,setYear] = useState<number>()
   const [lotRequiredState,setLotRequiredState] = useState<boolean>(true)
   const [stockTransferSoInfo,setStockTransferSoInfo] = useState<any[]>([])
   const [selectedProductcategory,setSelectedProductCategory] = useState<ProductCategoryEnum>(ProductCategoryEnum.GI)
   const [gradeChange,setGradeChange] = useState<boolean>(false)
   const [selectedPackageType,setSelectedPackageType] = useState<PackageTypeEnum>(undefined)
   const [exportLots,setExportLots] = useState<any[]>([])
   const [exportLotData,setExportLotData] = useState<any[]>([])
   const baleService = new BaleService()
   const [selectedLots,setSelectedLots] = useState<any[]>([])
const [lotInfoModal,setLotInfoModal] = useState<boolean>(false)
const [filteredLots,setFilteredLots] = useState<any[]>([])
const [selectedRowKeys,setSelectedRowKeys] = useState<any[]>([])
   const {Option} = Select;

   useEffect(() => {

  form.setFieldsValue({
    reportingCases:1
  })

  setTimeout(() => {
  getRacks(varientId)
}, 300)

}, [])
 
   let location = useLocation();
   let data: any = location.state;
   useEffect(() => {
     console.log(data);
     if(data != undefined){
       form.setFieldsValue({'unitId': data.unitId})
       form.setFieldsValue({'plantId': data.unitId})
       form.setFieldsValue({'transactionType': data.jobPurpose});
       const unitId = GlobalVariableValues.productionVersion == 'V1' ? localStorage.getItem("unit_id") : form.getFieldValue('unitId') 
       getJobsList(data.jobPurpose)
       if(data.jobPurpose == TransactionType.reprocessing){
         getSOsAgainstJob(data.jobId,data.jobPurpose);
         getReportedQtyAgainstJob(data.jobId)
       }else{
         getSaleOrderData(unitId)
       }
       if(data.jobPurpose != TransactionType.Labsamples){
         setStockTypeDisable(true)
         form.setFieldsValue({'saleOrderId': data.saleOrderId});
         handleSaleOrder(data.saleOrderId);
       }else{
         setStockTypeDisable(false)
         form.setFieldsValue({'stockStatus' : StockTypeStatus.dummy})
       }
       form.setFieldsValue({'jobId': data.jobId});
       form.setFieldsValue({'reportingCases': 0});
       setJobId(data.jobId);
       setJobCode(data.jobCode)
       
     }
   },[data])

   const getDefaultNAStyle = () => {
  return packStyle.find(
    (e) => e.packingMethodName?.trim()?.toUpperCase() === 'N/A'
  );
};

const getLotAgainstBaleData = () => {
 let variantName = '';

if (form.getFieldValue('stockStatus') === StockTypeStatus.dummy) {

  const selectedVariant = products.find(
    v => v.productId === form.getFieldValue('productId')
  );

  variantName = selectedVariant?.product;

} else {

  const selectedSOItem = saleOrderItemsData.find(
    v => v.saleOrderItemId === form.getFieldValue('saleOrderItemId')
  );

  variantName = selectedSOItem?.varient
  ? selectedSOItem.varient.split('/')?.pop()?.trim()
  : '';
}
  const req = new BaleDateReq()

  req.baleFromDate = form.getFieldValue('baleFromDate')
    ? moment(form.getFieldValue('baleFromDate')).format('YYYY-MM-DD')
    : undefined

  req.baleToDate = form.getFieldValue('baleToDate')
    ? moment(form.getFieldValue('baleToDate')).format('YYYY-MM-DD')
    : undefined

    req.productId = form.getFieldValue('productId')
     req.variantName=variantName

  baleService.getLotAgainstBaleData(req).then((res) => {
    if (res.status) {
      setExportLots(res.data)
      setFilteredLots(res.data)
    } else {
      message.error('No lots found for selected bale date and product')
      setExportLots([])
      setFilteredLots([]);
    }
  }).catch((err) => {
    AlertMessages.getErrorMessage(err.message)
    setExportLots([])
  })
}

const getLotDataAgainstBaleDate = () => {
      let variantName = '';

if (form.getFieldValue('stockStatus') === StockTypeStatus.dummy) {

  const selectedVariant = products.find(
    v => v.productId === form.getFieldValue('productId')
  );

  variantName = selectedVariant?.product;

} else {

  const selectedSOItem = saleOrderItemsData.find(
    v => v.saleOrderItemId === form.getFieldValue('saleOrderItemId')
  );

 variantName = selectedSOItem?.varient
  ? selectedSOItem.varient.split('/')?.pop()?.trim()
  : '';
}
  const req = new BaleDateReq()

  req.baleFromDate = form.getFieldValue('baleFromDate')
    ? moment(form.getFieldValue('baleFromDate')).format('YYYY-MM-DD')
    : undefined

  req.baleToDate = form.getFieldValue('baleToDate')
    ? moment(form.getFieldValue('baleToDate')).format('YYYY-MM-DD')
    : undefined

  req.fromLot = form.getFieldValue('fromLot')
  req.toLot = form.getFieldValue('toLot')
  req.productId = form.getFieldValue('productId')
  req.variantName=variantName

  baleService.getLotDataAgainstBaleDate(req).then((res) => {
    if (res.status) {
      setExportLotData(res.data)

setSelectedLots([])

setSelectedRowKeys([])
    } else {
      message.error('No lots found for selected Bale date and product')
      setExportLotData([])
    }
  }).catch((err) => {
    AlertMessages.getErrorMessage(err.message)
    setExportLotData([])
  })
}

const handleFromLotChange = (val) => {

  form.setFieldsValue({
    toLot: undefined
  });

  const index = exportLots.findIndex(
    e => e.lotNumber === val
  );

  if(index >= 0){

    const data = exportLots.slice(index);

    setFilteredLots(data);

  } else {

    setFilteredLots(exportLots);
  }
}

   const onBaleDateSelect=()=>{
        getLotAgainstBaleData();
        getLotDataAgainstBaleDate()
   }
 
 
   const getAllMainPlants = () => {
     unitcodeService.getAllMainPlants().then((res) => {
       if (res.status) {
         setUnticodes(res.data);
         if(res.data.length === 1){
           form.setFieldsValue({'unitId': res.data[0].plantId});
         }
       } else {
         setUnticodes([]);
       }
     }).catch((err) => {
       AlertMessages.getErrorMessage(err.message);
       setUnticodes([]);
     });
   }
 
   const getReportedQtyAgainstJob = (jobId) => {
     const req= new JobIdRequest(jobId,null)
     warehouseService.getReportedQtyAgainstJob(req).then(res => {
       if(res.status){
         setPrevReportedQty(res.data[0].quantity)
       }
     })
   }
 
   let createdUser = '';
   createdUser = localStorage.getItem('createdUser');
   let plant = '';
   plant = localStorage.getItem('unit_id');
 
   useEffect(() => {
     console.log(form.getFieldsValue());
     if(plant === "3" || plant === "2"){
       setHideRackColumns(true);
     }
     else{
       setHideRackColumns(false);
     }
     if(data != undefined && data?.jobPurpose != TransactionType.Labsamples){
       form.setFieldsValue({stockStatus:StockTypeStatus.SaleOrder});
     }
     form.setFieldsValue({ packingCompleted: PackingStatus.YES })
     form.setFieldsValue({pouchesShortage : PackingStatus.NO})
     form.setFieldsValue({cartonsShortage : PackingStatus.NO})
     form.setFieldsValue({productCategory : ProductCategoryEnum.GI})
     setSelectedProductCategory(ProductCategoryEnum.GI)
     setHideColumns(false);
     setItemValidation(true);
     if(GlobalVariableValues.productionVersion == 'V1' || data != undefined){
       const unitId = form.getFieldValue('unitId') != undefined ? form.getFieldValue('unitId') : localStorage.getItem("unit_id")
       if(data?.jobPurpose == TransactionType.Labsamples){
         getDummySaleOrdersData(unitId)
       }else{
         getSaleOrderData(unitId);
       }
       getPackStyles(unitId);
     }
     getWarehousePersonsData()
     getRacks(undefined); 
     getTodayStockinInfo()
     getAllMainPlants()
 
   }, []);
 
   const getTodayStockinInfo = () => {
     const unitId = form.getFieldValue('unitId') != undefined ? form.getFieldValue('unitId') : localStorage.getItem('unit_id') 
     const req = new UnitRequest(unitId)
     req.stockInType = 'workOrder'
     warehouseService.getTodayStockInInfo(req).then(res => {
       if(res.status){
         setTodayStockInInfo(res.data)
       }else{
         setTodayStockInInfo([])
       }
     })
   }
 
   
   const columns : ColumnProps<any>[] = [
     {
         title: 'S No',
         key: 'sno',
         width: '70px',
         responsive: ['sm'],
         render: (text, object, index) => (page - 1) * 10 + (index + 1)
     },
     {
       title:'Reported Date',
       dataIndex:'reportedDate',
       render:(text,record) => {
         return(
           <>
           {record.reportedDate ? moment(record.reportedDate).format('YYYY-MM-DD') : '-'}
           </>
         )
       }
     },
    //  {
    //    title:'Transaction Type',
    //    dataIndex:'transactionType'
    //  },
     {
       title:'Stock Type',
       dataIndex:'stockType'
     },
     {
       title:'Customer PO',
       dataIndex:'poNumber'
     },
     {
       title:'Product',
       dataIndex:'shortCode'
     },
     {
       title:'LotCode',
       dataIndex:'lotCode'
     },
     {
       title:'Package Type',
       dataIndex:'packageType'
     },
     {
       title:'Tare Weight',
       dataIndex:'tareWeight',
        render: (value) => Number(Number(value).toFixed(2))
     },
     {
       title:'No Of packages',
       dataIndex:'masterCartons'
     },
     {
       title:'Quantity',
       dataIndex:'quantity',
        render: (value) => Number(Number(value).toFixed(2))
     },
     {
      title:'Total Quantity',
      dataIndex:'totalQuantity',
      render: (value,record) => Number(Number(Number(record.masterCartons) * Number(record.quantity)).toFixed(2))
    }
     // {
     //   title:'Loose Pouches',
     //   dataIndex:'loosePouches'
     // },
   ]

   const lotColumns : ColumnProps<any>[] = [
  {
    title:'Lot Number',
    dataIndex:'lotNumber'
  },
  {
    title:'Bale Date',
    dataIndex:'baleDate',
    render:(text,record) => (
      <>
        {record.baleDate ? moment(record.baleDate).format('YYYY-MM-DD') : '-'}
      </>
    )
  },
    {
    title:'Product',
    dataIndex:'name'
  },
  {
    title:'Quality',
    dataIndex:'quality'
  },
  {
    title:'Quantity',
    dataIndex:'quantity'
  },

]
 
   const getPackStyles = (unitId) => {
     packingMethodService.getAllActivePackingMethods().then((res) => {
      if (res.status) {

  setPackStyle(res.data);

  const defaultNA = res.data.find(
    (e) => e.packingMethodName?.trim()?.toUpperCase() === 'N/A'
  );

  if (defaultNA) {

    form.setFieldsValue({
      packStyleId: defaultNA.packingMethodId,
      packMethodId: defaultNA.packingMethodId
    });

    handlePackStyle(defaultNA.packingMethodId);

    // dummy flow onchange
    // onPackMethodChange();
  }
} else {
         setPackStyle([]);
       }
     }).catch((err) => {
       AlertMessages.getErrorMessage(err.message);
       setPackStyle([]);
     });
   }
 
 
   const getWarehousePersonsData = () => {
     employeeService.getActiveEmployeesByDept({employeeDept:"warehouse"}).then((res) => {
       if (res.status) {
         setEmployeeData(res.data);
         if(res.data.length === 1){
           form.setFieldsValue({'whIncharge': res.data[0].employeeName}); 
         }
       } else {
         setEmployeeData([]);
       }
     }).catch((err) => {
       AlertMessages.getErrorMessage(err.message);
       setEmployeeData([]);
     });
   }
 
   const mastesrBrandData = (masterBrand) => {
     setMasterBrandData(masterBrand);
   }

   const getendCustomerAddress = (value) => {
       endcustomerservice.getEndCustomerDataById({endCustomerId:value,isActive:true}).then((res) => {
         if (res.status) {
           setCustomerBrandsData(res.data.brandsInfo);
         } else {
           setCustomerBrandsData([]);
         }
       }).catch((err) => {
         AlertMessages.getErrorMessage(err.message);
         setCustomerBrandsData([]);
       });
     
   }
   
   const getRacks = (variantId) => {
     setRackPostionsDropDown([])
     let saleOrderId = form.getFieldValue("saleOrderId");
     let saleOrderItemId = form.getFieldValue("saleOrderItemId");
     let reportingCases = form.getFieldValue("reportingCases");
     let packStyle = form.getFieldValue("packStyleId");
     let stockStatus = form.getFieldValue("stockStatus");
     let plantId = GlobalVariableValues.productionVersion == 'V1' ? Number(localStorage.getItem("unit_id")) : form.getFieldValue('unitId');
     console.log(packStyle);
     if(plantId != undefined && saleOrderId != undefined && saleOrderItemId != undefined && reportingCases != undefined && stockStatus != undefined){
         form.setFieldsValue({rackPostion : undefined})
         rackPositionService.getAvailableRackPositionsForPlantId({plantId:plantId,saleOrderId:saleOrderId,saleOrderItemId:saleOrderItemId,mastersCartons:reportingCases,stockTypeStatus:stockStatus,varientId:undefined,packStyleId:packStyle}).then((res) => {
           if (res.status) {
             console.log(res.data)
             setRackPostionsDropDown(res.data);
             if(res.data.length > 0){
               form.setFieldsValue({rackPostion : res.data[0].rackPositionId})
             }
           }
           else {
             if (res.intlCode) {
               AlertMessages.getErrorMessage(res.internalMessage);
               setRackPostionsDropDown([]);
             } else {
               setRackPostionsDropDown([]);
               AlertMessages.getErrorMessage(res.internalMessage);
             }
           }
         }).catch((err) => {
             AlertMessages.getErrorMessage(err.message);
             setRackPostionsDropDown([]);
         });
     }
   }

   const getDummySaleOrdersData = (value) => {
     saleOrderService.getDummySaleOrders({ plantId: value }).then((res) => {
       if (res.status) {
         setSaleOrderData(res.data);
       } else {
         if (res.intlCode) {
           AlertMessages.getErrorMessage(res.internalMessage);
         } else {
           AlertMessages.getErrorMessage(res.internalMessage);
         }
         setSaleOrderData([]);
       }
     }).catch((err) => {
       AlertMessages.getErrorMessage(err.message);
       setSaleOrderData([]);
     });
   }
   const getSaleOrderData = (value) => {
     saleOrderService.getMTOSaleOrders({ plantId: value }).then((res) => {
       if (res.status) {
         setSaleOrderData(res.data);
       } else {
         if (res.intlCode) {
           AlertMessages.getErrorMessage(res.internalMessage);
         } else {
           AlertMessages.getErrorMessage(res.internalMessage);
         }
         setSaleOrderData([]);
       }
     }).catch((err) => {
       AlertMessages.getErrorMessage(err.message);
       setSaleOrderData([]);
     });
   }
   const getSaleOrderItems = (reqData) => {
     if(reqData > 0){
        setSaleOrderItemDetails(undefined);
       setSaleOrderItemsData([]);
       let req = new SaleOrderIdRequest(reqData)
       console.log(form.getFieldValue('productId'))
      
       if(form.getFieldValue('stockStatus') == StockTypeStatus.dummy){
         req.packStyleId = GlobalVariableValues.NAPackStyleId
         req.productId = form.getFieldValue('productId')
       }

       saleOrderService.getSaleOrderItemsForSoId(req).then(res => {
         if (res.status) {
           if(form.getFieldValue('stockStatus') == StockTypeStatus.dummy){
             if(res.data.length > 1){
               setsaveFlag(false)
               AlertMessages.getErrorMessage('More than 1 product is there for selected product and pack style and customer po')
             }else{
               setsaveFlag(true)
             }
           }
           setSaleOrderItemsData(res.data);
           if(form.getFieldValue('stockStatus') === "anticipated" || form.getFieldValue('stockStatus') === "dummy"){
             getendCustomerAddress(res.data[0].endCustomerId)
           }
           else if(form.getFieldValue('stockStatus') === "superDummy"){
             form.setFieldsValue({'packStyleId': res.data[0].packStyleId});
           }

           if(res.data.length === 1){
  console.log('okkk')

  form.setFieldsValue({
    saleOrderItemId: res.data[0].saleOrderItemId,
    reportingCases:1
  });


  setSaleOrderId(reqData);

  getSaleOrderItemDetails(res.data[0].saleOrderItemId);

  getRacks(undefined); 
}
           
          //  if(res.data.length === 1){
          //    console.log('okkk')
          //    form.setFieldsValue({ saleOrderItemId: res.data[0].saleOrderItemId });
          //    setSaleOrderId(reqData);
          //    getSaleOrderItemDetails(res.data[0].saleOrderItemId);
          //    getRacks(undefined); 
          //  }
           else{
             console.log('else')
            //  form.setFieldsValue({ saleOrderItemId: null });
            const existingValue = form.getFieldValue('saleOrderItemId');

  // clear only if nothing selected
  if (!existingValue) {
    form.setFieldsValue({ saleOrderItemId: undefined });
  }
           }
         } else {
           if (res.intlCode) {
             AlertMessages.getErrorMessage(res.internalMessage);
           } else {
             AlertMessages.getErrorMessage(res.internalMessage);
           }
           setSaleOrderItemsData([]);
         }
       }).catch(err => {
         AlertMessages.getErrorMessage(err.message);
         setSaleOrderItemsData([]);
       })
     }
   }

   const getSaleOrderItemDetails = (reqData) => {
     form.setFieldsValue({'saleOrderItemId' : Number(reqData)})
     saleOrderService.getSaleOrderItemDetails({ saleOrderId: form.getFieldValue("saleOrderId"), saleOrderItemId: reqData, stockType: form.getFieldValue("stockStatus") }).then(res => {
       if (res.status) {
         console.log(res.data);
         setSaleOrderItemDetails(res.data);
        const defaultNA = getDefaultNAStyle();

        const currentPackMethod = form.getFieldValue('packMethodId');
const currentPackStyle = form.getFieldValue('packStyleId');

form.setFieldsValue({
  packStyleId:
    currentPackStyle ??
    (defaultNA
      ? defaultNA.packingMethodId
      : res.data.packStyleId),

  packMethodId:
    currentPackMethod ??
    (defaultNA
      ? defaultNA.packingMethodId
      : res.data.packStyleId),

  tareWeight: res.data.tareWeight,
  reportingCases:1
});

// form.setFieldsValue({
//   packStyleId: defaultNA
//     ? defaultNA.packingMethodId
//     : res.data.packStyleId,
//     packMethodId: defaultNA
//     ? defaultNA.packingMethodId
//     : res.data.packStyleId,
//   tareWeight: res.data.tareWeight,
//   reportingCases:1
// });

if (defaultNA) {
  handlePackStyle(defaultNA.packingMethodId);
  //  onPackMethodChange();
}

// onPackageTypeChange('N/A')
         setSelectedPackageType(res.data.packageType)
         if(Number(localStorage.getItem('unit_id')) != 2 && form.getFieldValue("stockStatus") != "superDummy"){
           if(form.getFieldValue('transactionType') == TransactionType.stockTransfer){
           }else{
           }
         }
         if(form.getFieldValue("stockStatus") === "dummy"){
           getRacks(res.data.varientId) 
         }
         else{
           getRacks(undefined) 
         }
              } else {
         if (res.intlCode) {
           AlertMessages.getErrorMessage(res.internalMessage);
         } else {
           AlertMessages.getErrorMessage(res.internalMessage);
         }
         setSaleOrderItemDetails(undefined);
       }
     }).catch(err => {
       AlertMessages.getErrorMessage(err.message);
       setSaleOrderItemDetails(undefined);
     })
   }
   const getCodeList =(saleOrderId:number)=>{
     codeListMainService.geTracebilityCodeForSoId({saleOrderId:saleOrderId}).then((res) => {
       if (res.status) {
         setTraceCodeList(res.data);
       } else {
         if (res.intlCode) {
         } else {
         }
         setTraceCodeList([]);
       }
     }).catch(err => {
       AlertMessages.getErrorMessage(err.message);
       setTraceCodeList([]);
     })
   }
 
   const getProducts = (val) => {
     const req = new SaleOrderIdRequest(val)
     if(form.getFieldValue('transactionType') == TransactionType.stockTransfer){
       req.productIdArray = stockTransferSoInfo[0].variantId
       req.packStyleIdArray = stockTransferSoInfo[0].packStyleId
     }
     if(form.getFieldValue('soakingOutProduct') != undefined){
       req.soakingOutProduct = form.getFieldValue('soakingOutProduct')
     }
     saleOrderService.getSaleOrderItemsBySaleOrderId(req).then(res => {
       if(res.status){
         setProducts(res.data)
         if(form.getFieldValue('stockStatus') === "anticipated" || form.getFieldValue('stockStatus') === "dummy"){
           getendCustomerAddress(res.data[0].endCustomerId)
         }
       }else{
         setProducts([])
         AlertMessages.getErrorMessage(res.internalMessage)
       }
     })
   }
 
   const getJobCartonsLoosePouches = () => {
     const req = new CheckSoItemExistReq(null,form.getFieldValue('jobId'))
     if(form.getFieldValue('productId') != undefined){
       req.varientId = form.getFieldValue('productId')
     }
     if(form.getFieldValue('packMethodId') != undefined){
       req.packStyleId = form.getFieldValue('packMethodId')
     }
     stockInService.getJobCartonsLoosePouches(req).then(res => {
       if(res.status){
         if(form.getFieldValue('productId') != undefined && form.getFieldValue('packMethodId') != undefined){
           form.setFieldsValue({reportingCases:res.data[0].jobCartons })
           form.setFieldsValue({loosePouches:res.data[0].jobLoosePouches })
         }
       }
     })
   }

   const handleSaleOrder = (value) => {
     
     const transactionType = form.getFieldValue("transactionType");
     const stockType = form.getFieldValue("stockStatus");
   
     if(stockType == StockTypeStatus.dummy){
       getProducts(value)
     }
     
     if ((stockType === "SaleOrder" || stockType === "superDummy") && transactionType != "rm") {
       form.setFieldsValue({ isDamaged: PackingStatus.NO });
     }
     else{
       form.setFieldsValue({ isDamaged: PackingStatus.NO });
     }
 
     if (stockType === "SaleOrder" || stockType === "superDummy") {
 
       getPackStyles(localStorage.getItem("unitId"));
      //  form.setFieldsValue({ saleOrderItemId: '' });
       form.setFieldsValue({ reportingCases: 0 });
       getCodeList(value);
     }
 
     if(form.getFieldValue('stockStatus') != StockTypeStatus.dummy){
       getSaleOrderItems(value); 
     }
 
     setSaleOrderId(value);
     const defaultNA = getDefaultNAStyle();

if (defaultNA) {

  if (
  !form.getFieldValue('packStyleId') &&
  !form.getFieldValue('packMethodId')
) {
  form.setFieldsValue({
    packStyleId: defaultNA.packingMethodId,
    packMethodId: defaultNA.packingMethodId
  });
}

  // form.setFieldsValue({
  //   packStyleId: defaultNA.packingMethodId,
  //    packMethodId: defaultNA.packingMethodId
  // });

  handlePackStyle(defaultNA.packingMethodId);
  // onPackMethodChange();
}
     form.setFieldsValue({ code : null });
   }
   
   const saveData = (values: any) => {
     setBtnDisable(true)
     if(saveFlag){
       form.validateFields().then(res => {
         let qtyConditionCheckFlag = new Set<boolean>()
         console.log(res);
         console.log(form.getFieldValue('packStyleId'))
         if(res.transactionType == TransactionType.repacking){
           const packStyleRec = packStyle.filter(e => {return(e.packingMethodId == form.getFieldValue('packStyleId'))})
           const reportingQty = (Number(res.reportedCases) * Number(packStyleRec[0].noOfPouches) * Number(packStyleRec[0].pouchesPerRow)) + (Number(res.loosePouches) * Number(packStyleRec[0].pouchesPerRow))
           const totalQty = Number(prevReportedQty) + Number(reportingQty)
 
           if(totalQty > Number(data.totIssuedQuantity)){
             qtyConditionCheckFlag.add(false)
           }
 
         }
 
       if(!(qtyConditionCheckFlag.has(false))){
           if ((res.stockStatus == "dummy" && hideColumns) || res.stockStatus == "Anticipated") {
           
           }
           else {
             setBtnDisable(true);
             console.log(res);
             const values = new StockInRequestDto(res.saleOrderId, res.saleOrderItemId, res.reportingCases, res.palletType, res.palletId, res.rackPostion ? res.rackPostion : 1, res.loosePouches, res.lotCode,res.transactionType,res.code, res.coldStorageId, res.plantId, res.shifts, res.packingCompleted, res.stockStatus, res.reportingDate, res.count, undefined, isUpdate, res.manualReported, createdUser,createdUser,PackingStatus.NO,PackingStatus.NO,res.productCategory,jobId,res.isDamaged,res.remarks,undefined,0,res.stockStatus == "dummy" ? res.packMethodId : res.packStyleId,res.palletcode,res.freezer,res.jobCompleted,jobCode,year)
             values.rejectionFrom = form.getFieldValue('rejectionFrom')
             values.gradeChange = gradeChange
             values.soakingOutProduct = form.getFieldValue('soakingOutProduct')
             values.packageType = form.getFieldValue('packageType')
             values.tareWeight = form.getFieldValue('tareWeight')
             values.quantity = form.getFieldValue('quantity')
             values.stockInType='workOrder'
             console.log('values+++++++++++',values)
          
        //    stockInService.reportStock(values).then((res) => {
        //      if (res.status) {
        //        AlertMessages.getSuccessMessage(res.internalMessage);
        //        setReportingLogId(res.data.reportingLogId)
     
        //        form.setFieldsValue({
        //          rackPostion: undefined,
        //          reportingCases:0
        //        })
     
        //        setBtnDisable(false);
        //        getRacks(undefined)
        //        getTodayStockinInfo()
        //      } else {
        //        setBtnDisable(false);
        //        if (res.intlCode) {
        //          AlertMessages.getErrorMessage(res.internalMessage);
        //        } else {
        //          AlertMessages.getErrorMessage(res.internalMessage);
        //        }
        //      }
        //    }).catch((err) => {
        //      AlertMessages.getErrorMessage(err.message);
        //    })
       const finalLots = selectedLots.length > 0
  ? selectedLots
  : [{ lotNumber: values.lotCode }]

const payloadData = finalLots.map((lot) => {
  return {
    ...values,
    lotCode: lot.lotNumber,
    quantity: lot.quantity || 0,
    jobId: values.jobId || jobId,
    year:lot.year
  }
})

console.log('FINAL PAYLOAD', payloadData)

stockInService.reportWOStock(payloadData).then((res) => {

  if (res.status) {

    AlertMessages.getSuccessMessage(res.internalMessage)

    setReportingLogId(res.data.reportingLogId)

    form.setFieldsValue({
      rackPostion: undefined,
      reportingCases:0
    })

    setBtnDisable(false)

    getRacks(undefined)

    getTodayStockinInfo()

    setSelectedLots([])

    setSelectedRowKeys([])
    setExportLotData([])

  } else {

    setBtnDisable(false)

    AlertMessages.getErrorMessage(res.internalMessage)

  }

}).catch((err) => {

  setBtnDisable(false)

  AlertMessages.getErrorMessage(err.message)

})
         }
       }else{
         AlertMessages.getErrorMessage('Reported quantity should not exceed issued quantity against job')
       }
       }).catch((err) => {
         // console.log(err);
         AlertMessages.getErrorMessage(err.message);
       });
       
     }else{
       AlertMessages.getErrorMessage('More than 1 product is there for selected product and pack style and customer po')
     }
     
 
   }
   const getSOsAgainstJob =(value,transactionType)=>{
     forkliftService.getSosAgainstJob({jobId:value,transactionType:transactionType}).then((res) => {
       if(res.status){
         setSaleOrderData(res.data);
       }
       else{
         setSaleOrderData([]);
         if (res.intlCode) {
           AlertMessages.getErrorMessage(res.internalMessage);
         } else {
           AlertMessages.getErrorMessage(res.internalMessage);
         }
       }
     }).catch((err) => {
       AlertMessages.getErrorMessage(err.message);
       setSaleOrderData([]);
     });
   }
   const getJobsList =(value)=>{
     if (value == TransactionType.stockTransfer || value == TransactionType.repacking || value == TransactionType.reprocessing || value == TransactionType.rework){
       setLotRequiredState(false)
     }else{
       setLotRequiredState(true)
     }
     let plantId = GlobalVariableValues.productionVersion== 'V1' ? Number(localStorage.getItem("unit_id")) : form.getFieldValue('unitId');
     form.setFieldsValue({jobId : null})
     form.setFieldsValue({saleOrderId:null})
     form.setFieldsValue({saleOrderItemId:null})
     console.log(plantId);
       setStockTypeDisable(false)
     if(value!=='rm' && value !== 'stockTransfer'){
       forkliftService.getForkliftJobCodes({unitId:plantId,transactionType:value}).then((res) => {
         if (res.status) {
           if(res.data.length>0){
             setJobcodesData(res.data);
           }else{
             setJobcodesData([]);
           }
           
           setHidejobType(false);
           setIsJobcodeRequired(true);
         } else {
           setHidejobType(false);
           setIsJobcodeRequired(false);
           if (res.intlCode) {
             AlertMessages.getErrorMessage(res.internalMessage);
           } else {
             AlertMessages.getErrorMessage(res.internalMessage);
           }
          setJobcodesData([]);
         }
       }).catch((err) => {
         AlertMessages.getErrorMessage(err.message);
         setJobcodesData([]);
       });
     }
     if(value=='stockTransfer'){
       forkliftService.getForkliftJobCodes({unitId:plantId,transactionType:'stockTransfer'}).then((res) => {
         if (res.status) {
           if(res.data.length>0){
             setJobcodesData(res.data);
           }else{
             setJobcodesData([]);
           }
           
           setHidejobType(false);
           setIsJobcodeRequired(true);
         } else {
           setHidejobType(false);
           setIsJobcodeRequired(false);
           if (res.intlCode) {
             AlertMessages.getErrorMessage(res.internalMessage);
           } else {
             AlertMessages.getErrorMessage(res.internalMessage);
           }
          setJobcodesData([]);
         }
       }).catch((err) => {
         AlertMessages.getErrorMessage(err.message);
         setJobcodesData([]);
       });
     }
     else{
       setHidejobType(true);
     }
   }
   const handleStockType = (value) => {
     form.setFieldsValue({'reportingCases': 0});
     if(value=='superDummy' || value == 'SaleOrder'){
       setHidePackStyle(true)
     }
     else{
       setHidePackStyle(false)
     }
     const transactionType = form.getFieldValue("transactionType");
     const unitId = GlobalVariableValues.productionVersion == 'V1' ? localStorage.getItem("unit_id") : form.getFieldValue('unitId')
     if((transactionType === "repacking" || transactionType === "reprocessing") && (value === "SaleOrder" || value === "superDummy")){
       getJobsList(transactionType);
     }
     else if((transactionType === "repacking" || transactionType === "reprocessing") && (value === "dummy" || value === "Anticipated")){getDummySaleOrdersData(unitId)
     } 
 
     if ((value === "SaleOrder" || value === "superDummy") && transactionType != "rm") {
       form.setFieldsValue({ isDamaged: PackingStatus.NO });
     }
 
     form.setFieldsValue({ saleOrderId: null })
     form.setFieldsValue({ saleOrderItemId: null })
     setSaleOrderItemDetails(undefined)
     setStockStatus(value);
     setStockStatus(value);
     if(value === StockTypeStatus.dummy || value === StockTypeStatus.Anticipated){
       setIsTracecodeRequired(false);
     }
     else if(value === StockTypeStatus.SaleOrder || value === StockTypeStatus.superDummy){
       setIsTracecodeRequired(true);
     }
     if(value === StockTypeStatus.superDummy || value === StockTypeStatus.Anticipated){
       form.setFieldsValue({pouchesShortage : PackingStatus.YES})
       form.setFieldsValue({cartonsShortage : PackingStatus.YES})
     }
     else{
       form.setFieldsValue({pouchesShortage : PackingStatus.NO})
       form.setFieldsValue({cartonsShortage : PackingStatus.NO})
     }
     if (value === StockTypeStatus.dummy || value === StockTypeStatus.Anticipated) {
       setItemValidation(false);
       form.setFieldsValue({ packingCompleted: PackingStatus.NO })
       getDummySaleOrdersData(unitId);
     }
     else
       if (value == StockTypeStatus.SaleOrder) {
         form.setFieldsValue({ packingCompleted: PackingStatus.YES })
         setHideColumns(false);
         setItemValidation(true);
         getSaleOrderData(unitId);
       } else {
         form.setFieldsValue({ packingCompleted: PackingStatus.NO })
         setHideColumns(false);
         setItemValidation(true);
         getSaleOrderData(unitId);
       }
       getRacks(undefined); 
   }
   const handleSaleOrderItem = (value) => {
     getSaleOrderItemDetails(value);
   }
   const clearDependentFields = () => {
     form.setFieldsValue({ saleOrderId: null })
     form.setFieldsValue({ saleOrderItemId: null })
     form.setFieldsValue({ TransactionType: null })
     form.setFieldsValue({ jobId: null })
   }
   const handleColdStorage = (value) => {
 
   }
   const handlePackStyle = (value) => {
     console.log(value);
     console.log(packStyle.find(rec => rec.packingMethodId === value));
     getRacks(undefined);
   }
   const onReset = () => {
     form.resetFields();
   };

   const handleOk = () => {
     setIsModalVisible(false);
     getSaleOrderItems(saleOrderId)
   };
 
   const handleCancel = () => {
     setIsModalVisible(false);
     getSaleOrderItems(saleOrderId)
   };
   const handleJobcodes =(content,option)=>{
     setJobCode(option?.jobCode)
     let transactionType = form.getFieldValue("transactionType");
     const unitId = GlobalVariableValues.productionVersion == 'V1' ? localStorage.getItem("unit_id") : form.getFieldValue('unitId')
     if(transactionType == TransactionType.repacking){
       getSOsAgainstJob(content,transactionType);
     }else if (transactionType == TransactionType.Labsamples){
       getDummySaleOrdersData(unitId)
     }
     else{
       getSaleOrderData(unitId)
     }
     setJobId(content);
     
   }
 
   const printModalOpen =() => {
     setIsModalVisible(true); 
     setModalName('print')
   }
 
   const onProductChange = (val) => {
     const req = new SOVarientIdReq(form.getFieldValue('saleOrderId'),val)
       packingMethodService.getAllActivePackingMethods().then(res => {
       if(res.status){
         setDummyProductPackStyles(res.data)
         const defaultNA = res.data.find(
  (e) => e.packingMethodName?.trim()?.toUpperCase() === 'N/A'
);

// form.setFieldsValue({
//   packMethodId: defaultNA?.packingMethodId
// });

if (!form.getFieldValue('packMethodId')) {
  form.setFieldsValue({
    packMethodId: defaultNA?.packingMethodId
  });
}

if(defaultNA){
  onPackMethodChange();
}
       }else{
         AlertMessages.getErrorMessage(res.internalMessage)
       }
     })
   }
 
   const onPackMethodChange = () => {
     form.setFieldsValue({'reportingCases':undefined,'loosePouches':undefined})
     getSaleOrderItems(form.getFieldValue('saleOrderId'))
     getJobCartonsLoosePouches()
   }
 
   const onUnitChange = (val) => {
     getTodayStockinInfo()
     getSaleOrderData(val);
     getPackStyles(val);
     form.setFieldsValue({plantId:val})
   }
 
 
   const onProductCategoryChange = (val,option) => {
     setSelectedProductCategory(option?.productCategoryName)
     if(option?.productCategoryName == ProductCategoryEnum.RRP){
     }
   }
 
 
   const onPackageTypeChange = (val) => {
     setSelectedPackageType(val)
   }
 
   return (
     <>
       <Card
        //  title={<span style={{ color: 'white' }}> Stock In</span>}
        //  style={{ textAlign: 'center' }}
        //  headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
         >
         <Form
           layout="vertical"
           form={form}
           name="control-hooks"
           onFinish={saveData}
         >
           <Form.Item
             style={{ display: 'none' }}
             name="createdUser"
             initialValue={createdUser}
           >
             <Input hidden />
           </Form.Item>
           <Form.Item style={{ display: "none" }} name="targetPosition" >
             <Input hidden />
           </Form.Item>
           <Form.Item style={{ display: "none" }} name="manualReported" initialValue={true}>
             <Input hidden />
           </Form.Item>
           <Form.Item style={{ display: "none" }} name="currentPosition" >
             <Input hidden />
           </Form.Item>
           <Form.Item style={{ display: "none" }} name="palletType" initialValue={PalletType.new}>
             <Input hidden />
           </Form.Item>
           
           <Form.Item style={{ display: "none" }} name="plantId" initialValue={Number(localStorage.getItem('unit_id'))}>
             <Input hidden />
           </Form.Item>
           
           <Form.Item style={{ display: "none" }} name="palletId" initialValue={1}>
             <Input hidden />
           </Form.Item>
           
           <Row gutter={24}>
             {
               GlobalVariableValues.productionVersion == 'V2' ? (<>
               
             <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                 <Form.Item name="unitId" label="Unit" 
                   rules={[
                     {
                       required: true, message: 'Missing Unit',
                     },
                   ]}
                 >
                   <Select
                   showSearch
                   optionFilterProp="children"
                   placeholder="Select Unit"
                   allowClear
                   onChange={onUnitChange}
                 >
                   {
                     unitCodes.map(e => {
                       return(
                         <Option key={e.plantId} value={e.plantId}>{e.plantCode}</Option>
                       )
                     })
                   }
                 </Select>
                 </Form.Item>
               </Col>
               </>) : (<></>)
             }
           <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
             <Form.Item name="reportingDate" label = "Date" initialValue={moment()}
             rules={[
               {
                 required: true, message: 'Missing Date',
               },
             ]}
             >
               <DatePicker disabledDate={(current) => current.isAfter(moment())} showTime={{ format: "HH:mm" }} style={{ width: '100%' }} format="YYYY-MM-DD HH:mm:ss"
                 showToday={true} defaultValue={moment('YYYY-MM-DD HH:mm:ss')} />
             </Form.Item>
           </Col>
             
         
           <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
               <Form.Item
                 name="transactionType"
                 label="Transaction Type"
                 initialValue={TransactionType.rm}
                 rules={[
                   {
                     required: true, message: 'Missing Transaction Type',
                   },
                 ]}
 
               >
                 <Select
                    onChange={getJobsList}
                   allowClear
                   onClear={clearDependentFields}
                 >
                   {transactionTypeDropDown.map(transactionType => {
                     return <Option value={transactionType.value}>{transactionType.name}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>
             {  !hidejobType  ?
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
 
               <Form.Item
                 name="jobId"
                 label="Job Code"
                 rules={[
                   {
                     required: isJobcodeRequired, message: 'Missing Job code',
                   },
                 ]}
               >
                 <Select
                   placeholder="Select Jobcode"
                   onChange={handleJobcodes}
                   allowClear
                   showSearch
                   filterOption={(input, option) =>
                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                   }
                 >
                   <Option value={null}>Please select</Option>
                   {jobcodesData.map(jobcodesDropdown => {
                     return <Option value={jobcodesDropdown.jobId} jobCode = {jobcodesDropdown.jobCode}>{jobcodesDropdown.jobCode}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>:""}
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
               <Form.Item
                 name="stockStatus"
                 label="Stock Type"
                 rules={[
                   {
                     required: true, message: 'Missing Stock Type',
                   },
                 ]}
 
               >
                 <Select
                   placeholder="Select Stock Type"
                   onChange={handleStockType}
                   allowClear
                   onClear={clearDependentFields}
                   disabled={form.getFieldValue('transactionType') == StockTypesEnum.RE_PACK || data?.jobPurpose == 'labsamples' || form.getFieldValue('transactionType') == TransactionType.Labsamples ? true : false}
                 >
                   <Option value={undefined}>Please select StockType</Option>
                   {stockType.map(stockType => {
                     return <Option value={stockType.value}>{stockType.name}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>
 
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
               <Form.Item
                 name="saleOrderId"
                 label="Customer PO"
                 rules={[
                   {
                     required: true, message: 'Missing Sale Order',
                   },
                 ]}
               >
                 <Select
                   placeholder="Select Customer Po"
                   onChange={handleSaleOrder}
                   allowClear
                   showSearch
                   optionFilterProp='children'
                 >
                   {saleOrderData.map(saleOrderDropDown => {
                     return <Option value={saleOrderDropDown.saleOrderId}>{saleOrderDropDown.saleOrderNumber}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>
             
 
             {
               isTracecodeRequired?
               <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
 
               <Form.Item
                 name="code"
                 label="Trace Code"
                 rules={[
                   {
                     required: false, message: 'Missing Trace Code',
                   },
                 ]}
               >
                 <Select
                   placeholder="Select Trace Code"
                   allowClear
                   showSearch
                   filterOption={(input, option) =>
                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                   }
                 >
                   <Option value={null}>select Trace Code</Option>
                   {traceCodeList.map(res => {
                     return <Option value={res.tracebilityCodeId}>{res.tracebilityCode}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>
             :""
             }
 
             {
               form.getFieldValue('stockStatus') == StockTypeStatus.dummy ? (<>
                 <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:4}}>
                   <Form.Item
                     name="productId"
                     label="Product"
                     rules={[
                       {
                         required: form.getFieldValue('stockStatus')  == StockTypeStatus.dummy ? true : false, message: 'Missing Product',
                       },
                     ]}
                   >
                     <Select
                       placeholder="Select Product"
                       onChange={onProductChange}
                       allowClear
                       showSearch
                       optionFilterProp='children'
                     >
                       {products?.map(e => {
                         return <Option value={e.productId}>{e.product}</Option>
                       })}
                     </Select>
                   </Form.Item>
                 </Col>
                 <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:4}}>
                   <Form.Item
                     name="packMethodId"
                     label="Pack Style"
                     rules={[
                       {
                         required: form.getFieldValue('stockStatus')  == StockTypeStatus.dummy ? true : false, message: 'Missing Pack Style',
                       },
                     ]}
                     hidden
                   >
                     <Select
                       placeholder="Select Pack Style"
                       onChange={onPackMethodChange}
                       allowClear
                       showSearch
                       optionFilterProp='children'
                     >
                       {dummyProductPackStyles?.map(e => {
                         return <Option value={e.packingMethodId}>{e.packingMethodName}</Option>
                       })}
                     </Select>
                   </Form.Item>
                 </Col>
               
               </>) : (<></>)
             }
          
             
             {
               !hideColumns ?
               <>
                 <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:12}} xl={{span:5}}>
                   <Form.Item
                     name="saleOrderItemId"
                     label="SO Item"
                     rules={[
                       {
                         required: itemValidation, message: 'Missing Sale Order Item',
                       },
                     ]}
                   >
                     <Select
                       placeholder="Select Sale Order Item"
                       onChange={handleSaleOrderItem}
                       allowClear
                       showSearch
                       optionFilterProp='children'
                       disabled={form.getFieldValue('stockStatus') == StockTypeStatus.dummy ? true : false}
                     >
                       {saleOrderItemsData?.map(saleOrderDropDown => {
                         return <Option value={saleOrderDropDown.saleOrderItemId}>{saleOrderDropDown.varient}</Option>
                       })}
                     </Select>
                   </Form.Item>
                 </Col>
               </>
                 : ""
             }
             {
               hidePackStyle?
               <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
                 <Form.Item name="packStyleId" label="Pack Style"
                   rules={[
                     {
                       required: hidePackStyle, message: 'Missing Pack Style',
                     },
                   ]}>
                   <Select
                     placeholder="Select Pack Style"
                     onChange={handlePackStyle}
                     allowClear
                     showSearch
                     optionFilterProp='children'
                   >
                     {packStyle?.map(dropdown => {
                       return <Option value={dropdown.packingMethodId}>{dropdown.packingMethodName}</Option>
                     })}
                   </Select>
                 </Form.Item>
               </Col>
               :""
             }
         
             {
               (form.getFieldValue("stockStatus") === StockTypeStatus.dummy || form.getFieldValue("stockStatus") === StockTypeStatus.Anticipated) && form.getFieldValue("saleOrderId")?
                 <Col span={4} style={{paddingTop:'30px'}}>
                   <Button type="primary" hidden={false} onClick={() =>{setIsModalVisible(true); setModalName('items')}} style={{ backgroundColor: '#40a9ff' }}>+Add New Product</Button>
                 </Col>
               :""
             }
             <Modal
               title="Add Product"
               key={'modal' + Date.now()}
               width={'80%'}
               style={{ top: 30, alignContent: 'right' }}
               visible={isModalVisible}
               onCancel={handleCancel}
               footer={[
               ]}>
              { modalName == 'items' ? <ItemDetailsForm key={itemsKey} mastesrBrandData={mastesrBrandData} 
               brandsData={customerBrandsData} category={selectedCategory} 
               soStatus={saleOrderDetails?.soStatus} packCategory={saleOrderDetails?.category} currency={selectedCurrency} updateCurrency={saleOrderDetails?.currencyId} stockStatus={stockStatus} saleOrderId={form.getFieldValue("saleOrderId")} closeModal={handleOk} varientsData={saleOrderItemsData} /> : <StockinPrint  reportingLogId={reportingLogId}/>
             }</Modal>
             <Col xs={{span:12}} sm={{span:12}} md={{span:4}} lg={{span:3}} xl={{span:4}}>
               <Form.Item name='packageType' label='Package Type' rules={[{required:true,message:'Missing Package Type'}]}>
                 <Select allowClear showSearch placeholder="Select Package Type" optionFilterProp='children' onChange={onPackageTypeChange}>
                   {
                     Object.values(PackageTypeEnum).map(e => {
                       return(
                         <Option key={e} value={e}>{e}</Option>
                       )
                     })
                   }
                 </Select>
               </Form.Item>
             </Col>
             <Col xs={{span:12}} sm={{span:12}} md={{span:4}} lg={{span:3}} xl={{span:4}}>
                             <Form.Item name='tareWeight' label='Tare Weight' rules={[{required:true,message:'Missing Tare Weight'},{validator: (_, value) => value >= 0 ? Promise.resolve() : Promise.reject(new Error('Enter only positive values'))}]}>
                               <Input placeholder='Enter Tare Weight'/>
                             </Form.Item>
                         </Col>
             <Col xs={{span:12}} sm={{span:12}} md={{span:4}} lg={{span:3}} xl={{span:4}}>
               <Form.Item name="reportingCases" label={`No Of. ${selectedPackageType != undefined ?  selectedPackageType : 'Cartons'}`}
 
                 rules={[
                   {
                     required: true,
                     message: 'Missing Reporting Cases',
                     validator: (_, value) =>
                       value >= 0 ? Promise.resolve() : Promise.reject(new Error('Enter only positive values')),
                   },
                 ]}  initialValue={1}>
                 <Input type='number' min={(0)}
                 onBlur={() => {getRacks(varientId)}} disabled
                 />
               </Form.Item>
             </Col>
             <Col xs={{span:12}} sm={{span:12}} md={{span:4}} lg={{span:3}} xl={{span:4}} hidden>
               <Form.Item name="loosePouches" label="Loose Pouches"
                 initialValue={0}>
                 <Input type='number' min={(0)}/>
               </Form.Item>
             </Col>
 
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
               <Form.Item
                 name="shifts"
                 label="Shift"
                 rules={[
                   {
                     required: true, message: 'Missing Shift',
                   },
                 ]}
                 initialValue="General"
                
               >
                 <Select
                   placeholder="Select Shifts"
                   allowClear
                 >
                    <Option key={'General'} value={'General'}>General</Option>
                   <Option key={'DAY'} value={'DAY'}>Day</Option>
                   <Option key={'NIGHT'} value={'NIGHT'}>Night</Option>
                 </Select>
               </Form.Item>
             </Col>
 
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
               <Form.Item name="whIncharge" label="WH Incharge"
                 rules={[
                   {
                     required: true, message: 'Missing WH Incharg',
                   },
                 ]}
               >
                  <Select
                   placeholder="Select WH Incharge"
                   allowClear
                   showSearch
                   filterOption={(input, option) =>
                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                   }
                 >
                   {employeeData.map(dropData => {
                   return <Option value={dropData.employeeName}>{`${dropData.employeeName}`}</Option>
                 })}
                 </Select>
               </Form.Item>
             </Col>
                 <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
                   <Form.Item
                     name="rackPostion"
                     label="Rack Position"
                     rules={[
                       {
                         required: true, message: 'Missing Rack Position',
                       },
                     ]}
                   >
                     <Select
                       placeholder="Select Rack Position"
                       allowClear
                       showSearch
                       filterOption={(input, option) =>
                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                       }
                     >
                       <Option value={undefined}>Select Rack Position</Option>
                       {rackPostionsDropDown.map(res => {
                         return <Option value={res.rackPositionId}>{res.rackCode}</Option>
                       })}
                     </Select>
                   </Form.Item>
                 </Col>
 
             {  !hidejobType  ?
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
 
               <Form.Item
                 name="jobCompleted"
                 label="Job Completed"
                 rules={[
                   {
                     required: isJobcodeRequired, message: 'Missing Job code',
                   },
                 ]}
               >
                 <Radio.Group name = 'jobCompleted'>
                 <Radio value={true}>Yes</Radio>
                 <Radio value={false}>NO</Radio>
                 </Radio.Group>
               </Form.Item>
             </Col>:""}
           {!hideColumns && saleOrderItemDetails != undefined ?
             <Row gutter={24}>
               <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:24}}>
              
               {saleOrderItemDetails ?
                 <Descriptions column={{ xxl: 4, xl: 4, lg: 4, md: 3, sm: 2, xs: 2 }}>
                    <Descriptions.Item  label="Brand" style={{paddingLeft:'10px'}} >
                     {saleOrderItemDetails.brand ? saleOrderItemDetails.brand: ''}
                   </Descriptions.Item>
                   <Descriptions.Item label="Cases Req.">
                     {saleOrderItemDetails.jobCases ? saleOrderItemDetails.jobCases : ''}
                   </Descriptions.Item>
                   <Descriptions.Item label="Reported Cases" style={{paddingLeft:'10px'}}>
                     {saleOrderItemDetails.reportedCases ? saleOrderItemDetails.reportedCases : 0}
                   </Descriptions.Item>
                 </Descriptions>
                 : ""}
                  </Col>
             </Row>
             : ""}
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
               <Form.Item name="coldStorageId" label="Cold Storage"
                 rules={[
                   {
                     required: false, message: 'Missing Cold Storage',
                   },
                 ]}>
                 <Select
                   placeholder="Select Cold Storage"
                   onChange={handleColdStorage}
                   allowClear
                 >
                   {zoneDropDown?.map(dropdown => {
                     return <Option value={dropdown.zoneId}>{dropdown.zoneName}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>
             
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
               <Form.Item name="packingCompleted" label="Packing Completed"
                 rules={[
                   {
                     required: true, message: 'Missing Packing Status',
                   },
                 ]}
               >
                 <Select
                   placeholder="Select packing Status"
                   allowClear
                   defaultValue={PackingStatus.NO}
                 >
                   <Option value="null">Select Packing Status</Option>
                   <Option value={PackingStatus.NO}>{PackingStatus.NO}</Option>
                   <Option value={PackingStatus.YES}>{PackingStatus.YES}</Option>
                 </Select>
               </Form.Item>
             </Col>
             <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}} hidden>
               <Form.Item
                 name="productCategory"
                 label="Product Category"
                 rules={[
                   {
                     required: true, message: 'Missing Product Category',
                   },
                 ]}
               >
                 <Select
                   placeholder="Select Product Category"
                   allowClear
                   showSearch
                   optionFilterProp='children'
                   onChange={onProductCategoryChange}
                 >
                   {categories.map(item => {
                     return <Option value={item.value} productCategoryName={item.name}>{item.name}</Option>
                   })}
                 </Select>
               </Form.Item>
             </Col>
           
             <Col span={7}>
               <Form.Item name="remarks" label="Remarks">
                   <TextArea showCount  />
               </Form.Item>
             </Col>
           
           </Row>
           <Row gutter={24} style={{width:'100%'}}>
  
  <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
    <Form.Item
      name="baleDateRange"
      label="Bale Date"
      rules={[
        {
          required:true,
          message:'Select Bale Date'
        }
      ]}
    >
      <DatePicker.RangePicker
        style={{width:'100%'}}
        onChange={(dates) => {
          form.setFieldsValue({
            baleFromDate: dates ? dates[0] : undefined,
            baleToDate: dates ? dates[1] : undefined
          })

          if(dates){
            getLotAgainstBaleData()
          }
        }}
      />
    </Form.Item>
  </Col>

  <Form.Item name="baleFromDate" hidden>
    <Input />
  </Form.Item>

  <Form.Item name="baleToDate" hidden>
    <Input />
  </Form.Item>

  <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
    <Form.Item
      name="fromLot"
      label="From Lot"
    >
      <Select
        allowClear
        showSearch
        placeholder="Select From Lot"
        optionFilterProp='children'
        onChange={handleFromLotChange}
      >
        {
         (exportLots || [])?.map((e) =>  {
            return(
              <Option value={e.lotNumber}>
                {e.lotNumber}
              </Option>
            )
          })
        }
      </Select>
    </Form.Item>
  </Col>

  <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:4}}>
    <Form.Item
      name="toLot"
      label="To Lot"
    >
      <Select
        allowClear
        showSearch
        placeholder="Select To Lot"
        optionFilterProp='children'
      >
        {
  (filteredLots.length > 0
    ? filteredLots
    : exportLots
  )?.map((e) => {
    return(
      <Option value={e.lotNumber}>
        {e.lotNumber}
      </Option>
    )
  })
}
      </Select>
    </Form.Item>
  </Col>

  <Col style={{paddingTop:'30px'}}>
    <Button
      type='primary'
      onClick={getLotDataAgainstBaleDate}
    >
      Get Lot Info
    </Button>
  </Col>

</Row>
{
  exportLotData.length > 0 && (
    <Col span={24} style={{marginTop:'20px'}}>
      <Table
        rowKey={'lotNumber'}
        columns={lotColumns}
        dataSource={exportLotData}
        pagination={false}
        rowSelection={{
          type:'checkbox',
          selectedRowKeys:selectedRowKeys,
          onChange:(keys, rows) => {
            setSelectedRowKeys(keys)
            setSelectedLots(rows)
          }
        }}
      />
    </Col>
  )
}

           <Row>
           <Col>
             <Button type="primary" htmlType="submit" block disabled={btnDisable}>
               Submit
             </Button>
             </Col>
             <Col>
             <Button
               htmlType="button"
               style={{ margin: '0 14px' }}
               onClick={onReset}
             >
               Reset
             </Button>
           </Col>
           <Col hidden={reportingLogId?false:true}>
             <Button type="primary" onClick={printModalOpen} >
               Print previous transaction
             </Button>
             </Col>
           </Row>
         </Form>
         
         <br/>
         {
           todayStockInInfo.length > 0 ? (<>
           <Row gutter={24}>
           <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:6}} xl={{span:24}}>
           <Table columns={columns} dataSource={todayStockInInfo}/>
           </Col>
           </Row>
           </>) : (<></>)
         }
         
       </Card>
     </>
   );
}

export default SpsaWOStockIn